import HomeHeader from "../components/home/homepage";
export default function HomeIndexPage() {
  return (
    <div className="ImageSection">
      <HomeHeader />
    </div>
  );
}
